import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getDeliveryCoverage = createAsyncThunk<any, any>(
  'getDeliveryCoverage',
  async (params = {}) => {
    const {vendor_id, is_enabled, delivery_method, tag} = params;
    let queryString = '';
    const queryParams: string[] = [];

    if (vendor_id) queryParams.push(`vendor_id=${vendor_id}`);
    if (is_enabled !== undefined && is_enabled !== null)
      queryParams.push(`is_enabled=${is_enabled}`);
    if (delivery_method) queryParams.push(`delivery_method=${delivery_method}`);
    if (tag) queryParams.push(`tag=${tag}`);

    if (queryParams.length > 0) {
      queryString = '?' + queryParams.join('&');
    }

    const response = await api.get(`dasht/delivery-coverage${queryString}`, {
      baseUrl: true
    });
    return response?.data;
  }
);

/** Fetches own + vendor_fleet coverage in parallel and merges polygons for پیک فروشگاه. */
export const getOwnDeliveryCoverage = createAsyncThunk<any, {vendor_id: string | number}>(
  'getOwnDeliveryCoverage',
  async ({vendor_id}) => {
    const getCoverage = (deliveryMethod: 'own' | 'vendor_fleet') =>
      api.get('dasht/delivery-coverage', {
        params: {
          vendor_id,
          delivery_method: deliveryMethod
        },
        baseUrl: true
      });

    const [ownResult, vendorFleetResult] = await Promise.allSettled([
      getCoverage('own'),
      getCoverage('vendor_fleet')
    ]);

    const own = ownResult.status === 'fulfilled' ? ownResult.value?.data : null;
    const vendorFleet =
      vendorFleetResult.status === 'fulfilled' ? vendorFleetResult.value?.data : null;

    if (!own && !vendorFleet) {
      throw new Error('Failed to fetch delivery coverage');
    }

    return {own, vendorFleet};
  }
);

export const enablePolygonDelivery = createAsyncThunk<any, any>(
  'enablePolygonDelivery',
  async ({polygonId, vendorId}: any) => {
    const response = await api.put(
      `dasht/delivery-coverage/${polygonId}/enable?vendor_id=${vendorId}`,
      null,
      {
        baseUrl: true
      }
    );
    return {status: response.data.status, request_id: response.data.request_id, polygonId};
  }
);

export const disablePolygonDelivery = createAsyncThunk<any, any>(
  'disablePolygonDelivery',
  async ({polygonId, vendorId}: any) => {
    const response = await api.put(
      `dasht/delivery-coverage/${polygonId}/disable?vendor_id=${vendorId}`,
      null,
      {
        baseUrl: true
      }
    );
    return {status: response.data.status, request_id: response.data.request_id, polygonId};
  }
);
